export enum RoleEnum {
    ROLE_ADMIN = 'ROLE_ADMIN',
    ROLE_SELLER = 'ROLE_SELLER',
    INVALID_USER = 'INVALID_USER'
}